var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4251 2.49988C24.6626 2.49988 27.5001 5.47488 27.5001 9.89988V20.1136C27.5001 24.5249 24.6626 27.4999 20.4251 27.4999H9.58762C5.35012 27.4999 2.50012 24.5249 2.50012 20.1136V9.89988C2.50012 5.47488 5.35012 2.49988 9.58762 2.49988H20.4251ZM20.2251 11.2499C19.8001 10.8249 19.1001 10.8249 18.6751 11.2499L13.5126 16.4124L11.3251 14.2249C10.9001 13.7999 10.2001 13.7999 9.77512 14.2249C9.35012 14.6499 9.35012 15.3374 9.77512 15.7749L12.7501 18.7374C12.9626 18.9499 13.2376 19.0499 13.5126 19.0499C13.8001 19.0499 14.0751 18.9499 14.2876 18.7374L20.2251 12.7999C20.6501 12.3749 20.6501 11.6874 20.2251 11.2499Z",
    fill: "#FF9966"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickSquare);
export default __webpack_public_path__ + "static/media/Tick-Square.626146954cf31bcfcdf00e5114446fbd.svg";
export { ForwardRef as ReactComponent };